// Admin › Mise en page : lecture des zones de blocs (ordre + visibilité) partagée par le web ET le mobile,
// pour qu'une désactivation ou un réordonnancement s'applique partout de la même façon.

// Clés d'une zone, dans l'ordre admin, en ne gardant que les blocs visibles ET activés.
// `pinned` = toujours affiché (ex. Paramètres) ; `defaults` sert tant que la zone n'est pas encore seedée.
export const zoneKeys = (config, zone, defaults = []) => {
  const blocks = (config?.layout_blocks || []).filter((b) => b.zone === zone);
  if (!blocks.length) return defaults;
  return blocks
    .filter((b) => b.pinned || (b.visible !== false && b.enabled !== false))
    .sort((a, b) => (a.order || 0) - (b.order || 0))
    .map((b) => b.key);
};

export const ACCOUNT_MENU_DEFAULT = [
  "account_manage_church", "account_resources", "account_settings", "account_my_lives", "account_invite",
  "account_finances", "account_support", "account_admin", "account_dark_mode",
];
export const accountMenuKeys = (config) => zoneKeys(config, "account_menu", ACCOUNT_MENU_DEFAULT);
